import { nativeReplace } from 'libs/open-link';
import urlParams from 'libs/query';
import bridge from 'libs/bridge';
import { ApplyReason, FetchPreApplyResponse } from 'pages/newaftersale/return/types';

// 显示金额
// format: 0.00
export function displayAmount(amount: string | number) {
    return typeof amount === 'string' ? amount : String(Number((amount / 100).toFixed(2)));
}

// 获取退款金额，用于后端 API 请求
export function getRefundAmountForAPI(
    amount: number | string,
    {
        isBeforeSale,
        isMultipleOrder
    }: {
        isBeforeSale: boolean;
        isMultipleOrder: boolean;
    }
) {
    if (isBeforeSale) {
        return 0;
    }

    if (isMultipleOrder) {
        return 0;
    }
    return amount;
}

export const jumpToDetail = ({
    isBeforeSale,
    isMultipleOrder,
    masterOrder,
    isMultipleProduct
}: {
    isBeforeSale: boolean;
    isMultipleOrder: boolean;
    isMultipleProduct?: boolean;
    masterOrder: FetchPreApplyResponse;
}) => {
    if (isMultipleProduct) {
        return nativeReplace(
            `/views/newaftersale/detail?id=${masterOrder.order_info.order_id}&before_sale=${Number(
                isBeforeSale
            )}${urlParams.hide_h5_title === '0' ? '&hide_h5_title=0' : ''}`
        );
    }

    if (isBeforeSale) {
        return nativeReplace(
            `/views/newaftersale/detail?id=${urlParams.id}&before_sale=${Number(isBeforeSale)}${
                urlParams.hide_h5_title === '0' ? '&hide_h5_title=0' : ''
            }`
        );
    }

    if (!isMultipleOrder) {
        return nativeReplace(
            `/views/newaftersale/detail?id=${masterOrder.order_info.order_id}&before_sale=${Number(
                isBeforeSale
            )}${urlParams.hide_h5_title === '0' ? '&hide_h5_title=0' : ''}`
        );
    }

    if (bridge.supports('close')) {
        return bridge.call('close');
    }

    return window.history.back();
};

// 过滤原因
export function filterReasons(
    reasons: ApplyReason[],
    filterOptions: {
        isSupply7DayReturn: boolean;
    }
) {
    let newReasons = [...reasons];

    if (!filterOptions.isSupply7DayReturn) {
        newReasons = newReasons.filter((reason) => !reason.isNoReason);
    }

    return newReasons;
}
